module.exports = __webpack_public_path__ + "img/ice_troll_hut_small.5e619e8b.png";